import CONTROLLER from '../../APP/controller/CONTROLLER.js';
import Activate from '../../../event/Activate.js';
import Translate, { LANGUAGECODE } from '../../../event/Translate.js';
import Close from '../../../event/Close.js';
import Deactivate from '../../../event/Deactivate.js';
import CONFIRM, { confirmEl } from '../../COMPONENT/dialog/confirm/CONFIRM.js';
import { tab } from '../../DOM/button/switchbutton/tab/TAB.js';
import { span } from '../../DOM/span/SPAN.js';
import { icon } from '../../SVG/icon/ICON.js';
import { navheader } from '../../DOM/nav/navbar/navheader/NAVHEADER.js';
import { navfooter } from '../../DOM/nav/navbar/navfooter/NAVFOOTER.js';
import { text } from '../../DOM/text/TEXT.js';
import { SVGS } from '../../SVG/SVGS.js';
import BADGE_CIRCLE from '../../DOM/svg/components/badge_circle/BADGE_CIRCLE.js';
import { button } from '../../DOM/button/BUTTON.js';
import PANEFACTORY from '../../APP/page/PANEFACTORY.js';
import LOGIN, { loginDialog } from '../../APP/page/dialog/login/LOGIN.js';
import TABGROUP, { tabgroup } from '../../DOM/GROUP/buttongroup/tabgroup/TABGROUP.js';
import USEROPTIONS, { userOptionsDialog } from '../../APP/page/dialog/useroptions/USEROPTIONS.js';
import APPSETTINGS, { appSettingsDialog } from '../../APP/page/dialog/appsettings/APPSETTINGS.js';
/** An Application Controller
    @description An Application Controller (APP)
    The APP class is responsible for managing the overall application lifecycle,
    handling user interactions, and coordinating between different components.
    It contains the main application logic and serves as the entry point for the application,
    constructing the contents of the MAIN/PAGE Element.
    APP.launch() should be instantiated during the init phase of the html document
*/
export default class APP extends CONTROLLER {
    svgHelpers;
    paneFactory;
    /** Constructs an Application
        @param page Main Component
        @param config Application Configuration
    */
    constructor(page, config) {
        super(page, config);
        this.keyBindings();
        this.svgHelpers = {
            badgeCircle: new BADGE_CIRCLE()
        };
        this.paneFactory = new PANEFACTORY(this.page);
    }
    /** Sets application keybindings
        Make sure not to override ctrl-c/ctrl-v
    */
    keyBindings() {
        window.addEventListener('keydown', (event) => {
            if (event.ctrlKey || event.metaKey) {
                console.log('Debug Charcode', String.fromCharCode(event.which).toLowerCase());
                switch (String.fromCharCode(event.which).toLowerCase()) {
                    //case 'b':
                    //	  event.preventDefault();
                    //    event.stopPropagation();
                    //    console.log('ctrl-b', 'ctrl-b: Trigger Console');
                    //    this.main.footer.btn_prev.flip();
                    //    break;
                    case 's':
                        event.preventDefault();
                        event.stopPropagation();
                        console.log('ctrl-s', this.toString());
                        break;
                    //case 'f':
                    //    break;
                    case 'g':
                        event.preventDefault();
                        event.stopPropagation();
                        if (!this.page.footer.btn_next.hasClass('active')) {
                            console.log('ctrl-g', 'ctrl-g: Trigger Config');
                            this.page.footer.btn_next.flip();
                        }
                        break;
                    case 'q':
                        event.preventDefault();
                        event.stopPropagation();
                        console.log('ctrl-q', 'ctrl-q: Trigger Search');
                        this.page.btn_search.flip();
                        break;
                    case 'y':
                        event.preventDefault();
                        event.stopPropagation();
                        if (!this.page.footer.btn_next.hasClass('active')) {
                            console.log('ctrl-y', 'ctrl-y: Trigger Navigation');
                            this.page.footer.btn_next.flip();
                        }
                        break;
                    case '%': // Left Arrow
                        event.preventDefault();
                        event.stopPropagation();
                        console.log('ctrl-leftArrow', 'ctrl-leftArrow: Trigger Navigation');
                        this.page.btn_sidebarLeft.flip();
                        break;
                    case '\'': // Right Arrow
                        event.preventDefault();
                        event.stopPropagation();
                        console.log('ctrl-rightArrow', 'ctrl-rightArrow: Trigger Alerts');
                        this.page.btn_sidebarRight.flip();
                        break;
                    case '&': // Up Arrow
                        event.preventDefault();
                        event.stopPropagation();
                        console.log('ctrl-upArrow', 'ctrl-upArrow: Trigger Alerts');
                        this.page.btn_Perspectives.flip();
                        break;
                    case '(': // Down Arrow
                        event.preventDefault();
                        event.stopPropagation();
                        console.log('ctrl-downArrow', 'ctrl-downArrow: Trigger Console');
                        this.page.footer.btn_console.flip();
                        break;
                    default:
                    // Do nothing
                }
            }
        });
    }
    login(caller) {
        new LOGIN(this.page.getBody(), loginDialog(this.config.auth.url.login, caller, this.page.loader)).showModal();
    }
    clearUserSession() {
        ['token', 'refreshToken', 'userId', 'username', 'email', 'roles'].forEach((key) => window.sessionStorage.removeItem(key));
    }
    addLoginButton() {
        let btn_login = this.page.siteheader.header.navRight.addSwitch(button(span('Login', 'user-icon'), 'btn-login', icon(SVGS.USER), 'Toggle the User Menu (ctrl-u)'));
        btn_login.on('activate', () => this.login(btn_login));
    }
    addUserButton() {
        let btn_user = this.page.siteheader.header.navRight.addSwitch(button(span('User', 'user-icon'), 'btn-user', icon(SVGS.USER), 'Toggle the User Menu (ctrl-u)'));
        btn_user.on('activate', () => {
            let userDialog = new USEROPTIONS(this.page.getBody(), userOptionsDialog(btn_user, this.page.loader));
            userDialog.el.addEventListener('click', (e) => {
                const rect = userDialog.el.getBoundingClientRect();
                // If click is outside of dialog box, close it
                if (e.clientX < rect.left ||
                    e.clientX > rect.right ||
                    e.clientY < rect.top ||
                    e.clientY > rect.bottom) {
                    userDialog.closeDialog();
                }
            });
            userDialog.showModal();
        });
    }
    hasRole(role) {
        let roles = window.sessionStorage.getItem('roles');
        if (roles) {
            let rolesArray = roles.split(',');
            return rolesArray.includes(role);
        }
        return false;
    }
    /** Launches the application */
    launch() {
        console.log('App.launch("' + this.config.app.name + '")');
        this.page.loader.log(10, 'Validating ' + this.page.className + ' session...').then(() => {
            this.page.asyncValidateSession().then((isValid) => {
                if (isValid) {
                    this.page.logInfo('Session valid. Launching application for user:', window.sessionStorage.getItem('username'));
                }
                else {
                    this.page.logInfo('No valid session. Launching application as anonymous user');
                }
                // Clear any existing header nav buttons
                this.page.siteheader.header.navCenter.empty(false);
                // Load initial configuration
                this.page.asyncBuildConfig().then(() => {
                    /** Populate site-header  */
                    let btn_sidebarLeft = this.page.sidebarLeft.buttonGroupTop.addSwitch(button(span('', 'UI', 'ToggleSidebar'), 'toggle-left', icon(SVGS.DOUBLE_ARROW_RIGHT), 'Toggle the left sidebar (ctrl-left-arrow)', 'noLabel btn-toggle-sidebar'))
                        .on('activate', () => {
                        this.page.sidebarLeft.do(new Activate(btn_sidebarLeft));
                        window.sessionStorage.setItem('sidebar-left-active', '1');
                    })
                        .on('deactivate', () => {
                        this.page.sidebarLeft.do(new Deactivate(btn_sidebarLeft));
                        window.sessionStorage.removeItem('sidebar-left-active');
                    });
                    // let btn_search = this.page.siteheader.header.navRight.addSwitch(button('', 'toggle-search', icon(SVGS.MAGNIFYING_GLASS), 'Toggle the Search Menu', 'noLabel'))
                    // 	.on('activate', () => {
                    // 		let dialogEl = new DIALOG(
                    // 			this.page.getBody(),
                    // 			dialog(btn_search, 'dialog-search', 'Search Dialog', navheader(), navfooter())
                    // 		);
                    // 		dialogEl.showModal();
                    // 	});
                    let tabs_language = new TABGROUP(this.page.siteheader.header.navRight, tabgroup('language-switch', 'language-switch'));
                    let tab_language_en = tabs_language.addTab(tab('EN', icon(SVGS.CIRCLE_ENGLISH_48PX), 'tab-language-en', 'Switch to English', 'tab-language'))
                        .on('activate', () => {
                        this.page.logInfo(`Language switched to English (${LANGUAGECODE.CA_EN})`);
                        window.sessionStorage.setItem('language', LANGUAGECODE.CA_EN);
                        this.page.getConfig().translation.language.code = LANGUAGECODE.CA_EN;
                        this.page.asyncBuildConfig().then(() => this.page.do(new Translate(tab_language_en, LANGUAGECODE.CA_EN)));
                    });
                    let tab_language_fr = tabs_language.addTab(tab('FR', icon(SVGS.CIRCLE_FRENCH_48PX), 'tab-language-fr', 'Changer en français', 'tab-language'))
                        .on('activate', () => {
                        this.page.logInfo(`Langue changée en français (${LANGUAGECODE.CA_FR})`);
                        window.sessionStorage.setItem('language', LANGUAGECODE.CA_FR);
                        this.page.getConfig().translation.language.code = LANGUAGECODE.CA_FR;
                        this.page.asyncBuildConfig().then(() => this.page.do(new Translate(tab_language_fr, LANGUAGECODE.CA_FR)));
                    });
                    if (typeof window.sessionStorage.getItem('language') === 'string') {
                        if (window.sessionStorage.getItem('language') === LANGUAGECODE.CA_EN) {
                            tab_language_en.do(new Activate());
                        }
                        else if (window.sessionStorage.getItem('language') === LANGUAGECODE.CA_FR) {
                            tab_language_fr.do(new Activate());
                        }
                    }
                    else { // Default to English
                        tab_language_en.do(new Activate());
                    }
                    // Validate the session and load appropriate buttons
                    if (this.page.getMain().getLoginDisabled()) {
                        this.page.logInfo('Login Disabled: Skipping login button creation');
                    }
                    else {
                        if (typeof window.sessionStorage.getItem('token') === 'string') {
                            if (isValid) {
                                this.addUserButton();
                            }
                            else {
                                this.addLoginButton();
                            }
                        }
                        else {
                            this.addLoginButton();
                        }
                    }
                    let btn_sidebarRight = this.page.sidebarRight.buttonGroupTop.addSwitch(button(span('', undefined, 'UI', 'ToggleSidebar'), 'toggle-right', icon(SVGS.DOUBLE_ARROW_LEFT), 'Toggle the Right Sidebar (ctrl-right-arrow)', 'noLabel btn-toggle-sidebar'))
                        .on('activate', () => {
                        this.page.sidebarRight.do(new Activate(btn_sidebarRight));
                        window.sessionStorage.setItem('sidebar-right-active', '1');
                    })
                        .on('deactivate', () => {
                        this.page.sidebarRight.do(new Deactivate(btn_sidebarRight));
                        window.sessionStorage.removeItem('sidebar-right-active');
                    });
                    /**
                     * Load navigation tabs
                     */
                    console.log('Loading application panes based on user roles: ' + window.sessionStorage.getItem('roles'));
                    this.config.page.panes.forEach((pane) => {
                        let showPane = pane.role.every(role => this.hasRole(role));
                        if (showPane) {
                            this.page.logInfo('User has access to pane:', pane.label);
                            console.log('Adding pane tab:', pane.label, pane);
                            let t = this.page.siteheader.header.navCenter.addTab(tab(pane.label, icon(pane.icon), `tab-${pane.label}`, 'Activate tab'))
                                .on('activate', () => {
                                this.page.logInfo('Activated tab: ' + pane.label);
                                this.page.logDebug('Adding Pane:', pane.name);
                                let paneloader = this.paneFactory.makePane(pane);
                                this.page.sidebarLeft.tabGroup.empty(false);
                                pane.children.forEach((p) => {
                                    let showChildPane = p.role.every(role => this.hasRole(role));
                                    if (showChildPane) {
                                        // this.page.logInfo('User has access to pane:', p.label);
                                        this.page.sidebarLeft.tabGroup.addTab(tab(p.label, icon(p.icon), `btn-${p.name}`, p.label))
                                            .on('activate', () => {
                                            this.page.logInfo('Activated sidebar button: ' + pane.label + '::' + p.label);
                                            paneloader.initializePane(p.name);
                                        });
                                    }
                                    // else {
                                    // 	this.page.logInfo('User does NOT have access to pane:', p.label, 'Required roles:', p.role);
                                    // }
                                });
                                this.page.sidebarLeft.tabGroup.activateFirstButton();
                            });
                            let btn_close = t.buttonGroup.addButton(button(span('Close'), 'tab-close', icon(SVGS.CLOSE), 'Close this tab', 'btn-close'))
                                .on('click', (ev) => t.do(new Close()));
                            let btn_options = t.buttonGroup.addButton(button(span('Options'), 'tab-options', icon(SVGS.THREE_DOTS_VERTICAL), 'Open Options for this tab', 'btn-options'))
                                .on('click', (ev) => {
                                console.log('TODO: PAGE: Tab options');
                                let dialogEl = new CONFIRM(this.page.getBody(), confirmEl('tab-options', undefined, t, navheader(this.config.app.label, this.config.app.icon), navfooter(), text(), () => console.log('onload'), () => console.log('onunload')));
                                dialogEl.showModal();
                            });
                        }
                        else {
                            this.page.logInfo('User does NOT have access to pane:', pane.label, 'Required roles:', pane.role);
                        }
                    });
                    this.page.siteheader.header.navCenter.activateFirstButton();
                    // Add the 'Settings' to the button of the sidebar
                    let btn_config = this.page.sidebarLeft.buttonGroupBottom.addButton(button(span('Settings'), 'btn-config', icon(SVGS.GEAR), 'Open Application Configuration', 'btn-config'))
                        .on('click', () => {
                        console.log('TODO: PAGE: Open Configuration Pane');
                        let appSettings = new APPSETTINGS(this.page.getBody(), appSettingsDialog(btn_config, this.page.loader));
                        appSettings.showModal();
                    });
                    /** Set Sidebar Events */
                    // console.log('Set sidebar state');
                    if (window.sessionStorage.getItem('sidebar-left-active') === '1') {
                        btn_sidebarLeft.do(new Activate(btn_sidebarLeft));
                    }
                    if (window.sessionStorage.getItem('sidebar-left-active') === '1') {
                        btn_sidebarRight.do(new Activate(btn_sidebarRight));
                    }
                    this.page.sidebarLeft.on('mouseover', () => {
                        if (window.sessionStorage.getItem('sidebar-left-active') !== '1') {
                            btn_sidebarLeft.do(new Activate(btn_sidebarLeft));
                        }
                    });
                    this.page.sidebarLeft.on('mouseleave', () => {
                        if (window.sessionStorage.getItem('sidebar-left-active') === '1') {
                            btn_sidebarLeft.do(new Deactivate(btn_sidebarLeft));
                        }
                    });
                    this.page.sidebarRight.on('mouseover', () => {
                        if (window.sessionStorage.getItem('sidebar-right-active') !== '1') {
                            btn_sidebarRight.do(new Activate(btn_sidebarRight));
                        }
                    });
                    this.page.sidebarRight.on('mouseleave', () => {
                        if (window.sessionStorage.getItem('sidebar-right-active') === '1') {
                            btn_sidebarRight.do(new Deactivate(btn_sidebarRight));
                        }
                    });
                    // Perform the PAGE.translate() to ensure everything is localized
                    this.page.do(new Translate(this.page, this.page.getCurrentLanguageCode()));
                });
            });
        });
    }
}
